import { render, staticRenderFns } from "./ModalCard.vue?vue&type=template&id=4fe22072&scoped=true"
import script from "./ModalCard.vue?vue&type=script&lang=js"
export * from "./ModalCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe22072",
  null
  
)

export default component.exports